import { createPromiseClient } from "@apachedubbo/dubbo";
import { TriCompanyShipperConsigneeService } from "@onetakesolutions/cargogo-contract-web/TriCompanyDatabase_dubbo";
import transport from "../transport";

const client = createPromiseClient(TriCompanyShipperConsigneeService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
